export default {
  pickup: 'À emporter',
  delivery: 'Livraison',
  ongoing_order: 'Commande en cours',
  view_more: 'Appuyez pour afficher les détails',
  status: {
    rejected: {
      title: 'Commande refusée',
      description: 'Appuyez pour afficher les détails',
    },
    created: {
      description: 'Commande reçue',
    },
    reviewed: {
      description: 'Votre commande a été vue',
    },
  },
  order_type: {
    pickup: 'retrait',
    delivery: 'livraison',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} Votre commande a été vue',
    order_confirmed: '#{{number}} Heure confirmée {{time}}',
    order_preparation_up_time_changed: '#{{number}} Heure de {{type}} modifiée à {{time}}',
    order_preparing: 'Votre commande #{{number}} est en préparation',
    order_rejected: '#{{number}} commande refusée',
  },
  error_messages: {
    failed_to_load: 'Une erreur est survenue, veuillez réessayer.',
  },
};
